import React, { useState } from 'react';
import { useParams,useNavigate,useLocation} from "react-router";
import AuthBanner from './AuthBanner';
import { apiService } from '../services/apiService';

const ResetPassword = () => {
 
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);   
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false); 
  const [password, setPassword] = useState("");
  const [cpassword, setconfirmPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState('');
  
  const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token'); // Get the token from the query string
  const validateForm = () => {
    const newErrors = {};
    if (!password.trim()) {
      newErrors.password = "Password is required";
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }
    if (!cpassword.trim()) {
      newErrors.cpassword = "Confirm Password is required";
    } else if (password !== cpassword) {
      newErrors.cpassword = "Passwords do not match";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        // // Simulate API call for password reset
        const response = await apiService("auth/reset-password", "POST", {
            token, // Include the token from the URL
            password,
          });             
       
        console.log("Response:",response);
        navigate("/login",{
            state: { successMessage: response.message },
          }); // Navigate back to login after success
      } catch (err) {
        console.error("Error sending password reset email:", err);
        setServerError(err.message || "Failed to send password reset email. Please try again.");
      }
    }
  };

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      {/* Left Section (Banner + Text) */}
      <AuthBanner />

      {/* Right Section (Forgot Password Form) */}
      <div className="md:w-1/3 w-full flex items-center justify-center bg-white">
        <div className="w-full max-w-sm p-6 flex flex-col justify-between min-h-[500px]">
          <div>
            <div className="flex justify-between mb-4">
              <div className="text-3xl font-bold text-red-600">TOSHIBA</div>
            </div>

            <h2 className="text-2xl font-semibold text-[#000] mb-6">Reset Password</h2>
            {serverError && (
              <div className="mb-4 text-red-500 text-sm text-center">
                {serverError}
              </div>
            )}
            <form onSubmit={handleSubmit} className="flex flex-col">

            <div className="mb-4 ">
                <label htmlFor="password" className="block text-sm text-[#000] pb-1">
                  Password
                </label>
                <div className='relative'>
                  <input
                    type={isPasswordVisible ? 'text' : 'password'}  // Toggle type between text and password
                    id="password"
                    name="password"
                    placeholder="Enter Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={`w-full p-2 border border-[#6E757C] rounded-sm pr-10  ${
                      errors.password ? "border-red-500" : "border-[#6E757C]"
                    }`}  // Added pr-10 for padding right
                  />
                  {/* Eye icon for toggling password visibility */}
                  <img
                    src='/images/eye.png'
                    alt='view password'
                    className="absolute right-2  top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={()=>setIsPasswordVisible(!isPasswordVisible)}
                  />
                
                </div>
                {errors.password && (
                  <p className="text-red-500 text-xs mt-1 pt-2">{errors.password}</p>
                )}
              </div>
             

              <div className="mb-4 ">
                <label htmlFor="cpassword" className="block text-sm text-[#000] pb-1">
                  Confirm Password
                </label>
                <div className='relative'>
                  <input
                    type={isConfirmPasswordVisible ? 'text' : 'password'}  // Toggle type between text and password
                    id="cpassword"
                    name="cpassword"
                    placeholder="Enter Password"
                    value={cpassword}
                    onChange={(e) => setconfirmPassword(e.target.value)}
                    className={`w-full p-2 border border-[#6E757C] rounded-sm pr-10  ${
                      errors.cpassword ? "border-red-500" : "border-[#6E757C]"
                    }`}  // Added pr-10 for padding right
                  />
                  {/* Eye icon for toggling password visibility */}
                  <img
                    src='/images/eye.png'
                    alt='view password'
                    className="absolute right-2  top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={()=>setIsConfirmPasswordVisible(!isConfirmPasswordVisible)}
                  />
                  
                </div>
                {errors.cpassword && (
                  <p className="text-red-500 text-xs mt-1 pt-2">{errors.cpassword}</p>
                )}
              </div>

              <div className="flex items-center justify-between mb-2">
                <button
                  type="submit"
                  className="bg-[#3D3D3D] text-white py-2 px-6 rounded-sm w-full"
                >
                  <span className="text-white text-sm cursor-pointer">Submit</span>
                </button>
              </div>
            </form>
          </div>

          <div className="text-xs text-[#000] mt-6 text-center">
            Powered by Sparsh Communications Pvt. Ltd.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;